// Nuevo componente reusable AvatarFlowModal con todos los pasos y props

import styled from "styled-components";
import UiAvatarEditor from "react-avatar-editor";
import Image from "../../Image";
import Button from "../../Button";
import Error from "../../Form/Error";

/** Props solo usadas para estilos internos */
interface StyledProps {
  hasError?: boolean;
}

export const AvatarEditorStyled = styled(UiAvatarEditor)`
  border-radius: 0px;
  margin-bottom: 0px;
  margin-top: -24px;
  // position: relative;
  // top: -24px;
`;

export const Avatar = styled.div`
  position: relative;
  width: 100%;
  max-width: 140px;
  max-height: 140px;
  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    max-width: 160px;
    max-height: 160px;
  }
`;

export const UserAvatarContainer = styled.div`
  position: relative;
  max-width: 124px;
  max-height: 124px;
`

export const UserAvatar = styled(Image) <StyledProps>`
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  background-color: #F3F4F6;
  border: 1px solid ${({ hasError }) => hasError ? "red" : "#C4C4C4"};
`;

export const AvatarCta = styled.button`
  position: absolute;
  bottom: 4px;
  right: 10px;
  width: 24px;
  height: 24px;
  background-color: white;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #6c5ce7;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  cursor: pointer;
`;

export const Zoom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 192px;
  text-transform: uppercase;
  font-size: 12px;
  color: gray;
`;

export const Rotate = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 192px;
  text-transform: uppercase;
  font-size: 12px;
  color: gray;
`;

export const UpdatePicture = styled.label`
  cursor: pointer;
  border: 2px solid ${({ theme }) => theme?.colors?.Primary || "#6c5ce7"};
  background-color: ${({ theme }) => theme?.colors?.Primary || "#6c5ce7"};
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  border-radius: 20px;
  padding: 0px 17px;
  height: 40px;
  line-height: 36px;
  width: 100%;
  text-align: center;
  letter-spacing: 0.2px;
  transition: 0.2s ease-in-out;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.25) 0px 4px 4px;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  width: 100%;
`;

export const Cancel = styled(Button)`
  font-size: 16px;
  margin: 0;
  border-radius: 20px;
  width: 100%;
  font-weight: 500;
  line-height: 36px;
  height: 40px;
`;

export const SavePicture = styled(Button)`
  font-size: 16px;
  margin: 0;
  border-radius: 20px;
  width: 100%;
  font-weight: 500;
  line-height: 36px;
  height: 40px;
`;

export const Editor = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border-radius: 16px;
  padding: 24px 27px;
  overflow: hidden;
`;

export const ValidationError = styled.p`
  margin: 0;
  font-size: 12px;
  color: red;
  background: #ffe7e7;
  padding: 0 10px;
  border-radius: 12px;
`;

export const AvatarErrorMessage = styled(Error)`
  text-align: center;
`;

export const Title = styled.h2`
  font-weight: 500;
  font-size: 18px;
  line-height: normal;
  color: #2D3436;
  margin: 0px;
  text-align: center;
`;

export const Subtitle = styled.p`
  font-size: 12px;
  line-height: normal;
  color: #2D3436;
  margin: 0px;
  text-align: center;
`;

export const SuccessIcon = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: #d3f2d3;
  border: 1px solid #4CA154;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: #4caf50;
    width: 48px;
    height: 48px;
  }
`;
